import { NotifyHelper } from "../../../helpers/toast";
import { eSanPhamActionTypeDefine } from "../../action-types/san-pham/ISanPhamActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const sanPhamActions = {
    ...generateActions(eSanPhamActionTypeDefine, "SAN_PHAM"),
    ...generateActionForKey(eSanPhamActionTypeDefine, "SAN_PHAM", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eSanPhamActionTypeDefine, "SAN_PHAM", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eSanPhamActionTypeDefine, "SAN_PHAM", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eSanPhamActionTypeDefine, "SAN_PHAM", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eSanPhamActionTypeDefine, "SAN_PHAM", "SAVE_IMPORT_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eSanPhamActionTypeDefine, "SAN_PHAM", "SAVE_IMPORT_ERROR", (m) => { NotifyHelper.Error(m) }),
}